import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { Link } from "wouter";

import { useHashState } from "../../../stores/useHashState";
import { Drawer } from "../../../ui/Drawer/Drawer";
import { useHeaderLinks } from "../useHeaderLinks";
import { useLanguageSelect } from "../useLanguageSelect";
import { Hamburger } from "./Hamburger";

export const Sidebar: FunctionComponent = () => {
  const links = useHeaderLinks();
  const [visible, { hide, show }] = useHashState("#mobile-menu");
  const { oppositeLanguage, oppositeLanguageLink } = useLanguageSelect();

  return (
    <section className="md:hidden sidebar">
      <div className="h-16 w-16 md:h-20 md:w-20 md:mr-4 relative z-dialog-controls">
        <Hamburger
          onClick={(): void => {
            visible ? hide() : show();
          }}
          isOpen={visible}
        />
        <Drawer
          className="pl-16 md:pl-20 w-full max-w-[20rem]"
          onClose={hide}
          placement="left"
          visible={visible}
        >
          {links.map(({ href, isActive, name, to }) => {
            const linkClass = clsx(
              "block px-4 py-2",
              isActive && "bg-selected"
            );
            if (href) {
              return (
                <a className={linkClass} href={href} key={href}>
                  {name}
                </a>
              );
            }
            return (
              <Link key={to || href} to={to!}>
                <a className={linkClass}>{name}</a>
              </Link>
            );
          })}
          <hr className="my-1" />
          <Link to={oppositeLanguageLink}>
            <a className="block px-4 py-2">
              {oppositeLanguage === "en" ? "English" : "Français"}
            </a>
          </Link>
        </Drawer>
      </div>
    </section>
  );
};
